import { type JSX } from "react";

import { Box, Stack, Typography } from "@mui/material";

type Props = {
  title: string;
  subtitle?: string;
  children?: JSX.Element;
  dataCy?: string;
};

export function EmptyDashboardWithMessage({ title, subtitle, children, dataCy }: Props) {
  return (
    <Stack
      sx={{
        alignItems: "center",
        width: "100%",
      }}
    >
      <Stack
        sx={{
          height: "75vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h3"
          align="center"
          data-cy={dataCy}
          sx={{
            pt: 5,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            pt: 2,
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
        <Box sx={{ pt: 3 }}>{children}</Box>
      </Stack>
    </Stack>
  );
}
